import PaymentController from "./payment_controller.js";

export default class extends PaymentController {
  static targets = [
    "datatransForm",
    "cardNumber",
    "cardCVV",
    "newCardContainer",
    "newCardInput",
    "newCardDetails",
    "paymentMethod",
    "paymentMethodContainer",
    "submit",
    "cardBrand",
    "cardMonth",
    "cardYear",
  ];
  static values = {
    disableOnlinePayments: { type: Boolean, default: false },
    amount: { type: Number, default: 0 },
  };

  connect() {
    window.Parsley.setLocale(this.locale);

    this.checkBookingExpiration();

    if (this.disableOnlinePaymentsValue) return;

    this.inputFocusHandler();

    this.cardNumberTarget.addEventListener("input", (event) => {
      event.target.value = event.target.value.replace(/\s/g, "").substring(0, 16);
    });
  }

  checkBookingExpiration() {
    if (!this.data.has("check-expiration-url")) {
      return;
    }
    const url = this.data.get("check-expiration-url");

    setInterval(() => {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (data.expired) {
            location.reload();
          }
        });
    }, 60000); // 60000 ms = 1 minute
  }

  inputFocusHandler() {
    const that = this;
    [
      this.cardNumberTarget,
      this.cardCVVTarget,
      this.cardMonthTarget,
      this.cardYearTarget,
      this.cardBrandTarget,
    ].forEach((element, idx) => {
      element.addEventListener("focus", (event) => {
        that.selectNewCard();
      });
    });
  }

  // submitting the payment form after validating the form
  async submit(event) {
    event.preventDefault();
    if (await this.checkAmount() === false) return;
    if (this.validate) {
      Rails.disableElement(this.submitTarget);

      $(this.datatransFormTarget).trigger("submit.rails");
    }
  }

  async checkAmount() {
    if (!this.hasAmountValue) return true;

    const url = this.data.get("check-amount-url");
    if (!url) return true;

    let response;
    try {
      response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        },
        body: JSON.stringify({ amount: this.amountValue }),
      });
    } catch {
      return true; // network error — don't block checkout
    }

    if (!response.ok) return true; // non-2xx — don't block checkout

    const data = await response.json();
    if (!data.isCorrect) {
      window.location.reload();
      return false;
    }
    return true;
  }

  get validate() {
    if (this.disableOnlinePaymentsValue) {
      this.datatransFormTarget.action = this.datatransFormTarget.dataset.postfinanceInvoiceUrl;
      return $(this.datatransFormTarget).parsley().validate();
    }

    this.cardNumberTarget.removeAttribute('data-parsley-excluded');
    this.cardCVVTarget.removeAttribute('data-parsley-excluded');
    $(this.datatransFormTarget).parsley().reset();
    if (this.selectedPaymentCard === "false") {
      this.paymentMethodTarget.value = this.cardBrandTarget.value;
      return $(this.datatransFormTarget).parsley().validate();
    } else if (this.selectedPaymentCard === "isr") {
      this.datatransFormTarget.action = this.datatransFormTarget.dataset.postfinanceInvoiceUrl;
      this.cardNumberTarget.setAttribute('data-parsley-excluded', 'true');
      this.cardCVVTarget.setAttribute('data-parsley-excluded', 'true');
      return $(this.datatransFormTarget).parsley().validate();
    } else {
      this.paymentMethodTarget.value = this.selectedPaymentCard;
      this.cardNumberTarget.setAttribute('data-parsley-excluded', 'true');
      this.cardCVVTarget.setAttribute('data-parsley-excluded', 'true');
      return $(this.datatransFormTarget).parsley().validate();
    }
  }

  get locale() {
    const lang = this.data.get("locale");

    if (lang === "it") return "en";
    return lang;
  }
}
